import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import EVRouteMap from "../components/EVRouteMap";
import Modal from "../components/Modal";
import ContactFormGoElectric from "../components/ContactFormGoElectric";

/**
 * EV Roadshow Landing (Ford styling)
 * - Без: Интерактивен тур / галерия; „Защо Ford Professional?“; „Допълнителни услуги“
 * - Секции: Hero, Инфо, График по градове (дата + линк към дилър), Финален CTA
 *
 * TODO: Подмени dealerUrl за всеки град с реалния линк на дилърството.
 */

// Helpers: next/current stop + date formatting (ДД.ММ)
function startOfDayLocal(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function getNextOrCurrentStop(schedule) {
  const today = startOfDayLocal(new Date());
  // 1) Ongoing now: всички, които са в интервала днес
  const currentStops = schedule.filter((s) => {
    const sD = startOfDayLocal(new Date(s.startDate));
    const eD = startOfDayLocal(new Date(s.endDate));
    return today >= sD && today <= eD;
  });
  if (currentStops.length > 0) {
    return { items: currentStops, status: "now" };
  }
  // 2) Следващи: всички със същата най-близка начална дата
  const nextStart = schedule
    .map((s) => startOfDayLocal(new Date(s.startDate)))
    .filter((d) => d > today)
    .sort((a, b) => a - b)[0];
  if (nextStart) {
    const nextStops = schedule.filter(
      (s) =>
        startOfDayLocal(new Date(s.startDate)).getTime() === nextStart.getTime()
    );
    if (nextStops.length > 0) {
      return { items: nextStops, status: "next" };
    }
  }
  // 3) Finished
  return null;
}

function fmtDM(iso) {
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mm}`;
}

const SCHEDULE = [
  {
    city: "Пловдив",
    startDate: "2025-10-01",
    endDate: "2025-10-03",
    dealerEmail: "plovdiv@motopfohe.bg",
    venue: "Moto-Pfohe, ф-л Пловдив",
  },
  {
    city: "София",
    startDate: "2025-10-03",
    endDate: "2025-10-05",
    dealerEmail: "liulin2@motopfohe.bg",
    venue: "Moto-Pfohe, ф-л Младост",
  },
  {
    city: "Бургас",
    startDate: "2025-10-08",
    endDate: "2025-10-09",
    dealerEmail: "burgas@motopfohe.bg",
    venue: "Морска градина, пред Пантеона",
  },
  {
    city: "Стара Загора",
    startDate: "2025-10-11",
    endDate: "2025-10-12",
    dealerEmail: "starazagora@motopfohe.bg",
    venue:
      "пред централния вход на търговски комплекс HOLIDAY PARK Стара Загора",
  },
  {
    city: "Варна",
    startDate: "2025-10-09",
    endDate: "2025-10-12",
    dealerEmail: "varna@motopfohe.bg",
    venue: "Дворец на културата и спорта, Автомобилен салон Варна",
  },
  {
    city: "Добрич",
    startDate: "2025-10-15",
    endDate: "2025-10-16",
    dealerEmail: "dobrich@motopfohe.bg",
    venue: "пред паметника на Хан Аспарух по ул.Батовска",
  },
  {
    city: "Шумен",
    startDate: "2025-10-18",
    endDate: "2025-10-19",
    dealerEmail: "forsh@motopfohe.bg",
    venue: "на паркинга на „Арена Шумен”, ул. Марица №111",
  },
  {
    city: "Русе",
    startDate: "2025-10-21",
    endDate: "2025-10-22",
    dealerEmail: "russe@motopfohe.bg",
    venue: "ул. Александровска №57 пред Съдебната палата",
  },
  {
    city: "Велико Търново",
    startDate: "2025-10-24",
    endDate: "2025-10-25",
    dealerEmail: "velikotarnovo@motopfohe.bg",
    venue: "Автокомплекс Ford гр. Велико Търново, ул. Козлуджа 15",
  },
  {
    city: "Габрово",
    startDate: "2025-10-27",
    endDate: "2025-10-28",
    dealerEmail: "gabrovo@motopfohe.bg",
    venue: "бул. Стефан Караджа №2",
  },
  {
    city: "Плевен",
    startDate: "2025-10-30",
    endDate: "2025-10-31",
    dealerEmail: "pleven@motopfohe.bg",
    venue: 'бул. Европа №6, пред магазин "Зора"',
  },
  {
    city: "Монтана",
    startDate: "2025-11-04",
    endDate: "2025-11-05",
    dealerEmail: "montana@motopfohe.bg",
    venue: "площад Жаревица",
  },
  {
    city: "Благоевград",
    startDate: "2025-11-08",
    endDate: "2025-11-09",
    dealerEmail: "blagoevgrad@motopfohe.bg",
    venue: "пл. Георги Измирлиев",
  },
  {
    city: "Смолян",
    startDate: "2025-11-12",
    endDate: "2025-11-13",
    dealerEmail: "smolyan@motopfohe.bg",
    venue: 'ул. Петър Берон (паркинга на стадион "Смолян")',
  },
  {
    city: "Хасково",
    startDate: "2025-11-19",
    endDate: "2025-11-20",
    dealerEmail: "g.draganov@autobox.bg",
    venue: "бул. Съединение №98",
  },
];

export default function RoadshowEV() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [prefillCity, setPrefillCity] = useState("");
  const MODELS = [
    {
      name: "Puma",
      img: "https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_E_Puma-3x2-1000x667-e-puma-side-view.jpg",
      moreUrl: "https://ford.bg/cars/puma-gen-e",
      stockUrl: "https://sale.ford.bg/?model=PUMA+GEN-E",
    },
    {
      name: "Explorer",
      img: "https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_Explorer-3x2-1000x667-explorer-side-view.jpg",
      moreUrl: "https://ford.bg/cars/new-explorer",
      stockUrl: "https://sale.ford.bg/?model=E-EXPLORER",
    },
    {
      name: "Capri",
      img: "https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_Capri-3x2-1000x667-capri-side-view.jpg",
      moreUrl: "https://ford.bg/cars/capri",
      stockUrl: "https://sale.ford.bg/?model=CAPRI",
    },
    {
      name: "Mustang Mach-E",
      img: "https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_MachE-3x2-1000x667-mach-e-side-view.jpg",
      moreUrl: "https://ford.bg/cars/mustang-mach-e",
      stockUrl: "https://sale.ford.bg/?model=MACH-E",
    },
  ];

  // Responsive visible-cards: 1 (<640px), 2 (640–1023px), 3 (>=1024px)
  function useVisibleCards() {
    const [v, setV] = useState(1);
    useEffect(() => {
      const mqlSm = window.matchMedia("(min-width: 640px)");
      const mqlLg = window.matchMedia("(min-width: 1024px)");
      const update = () => setV(mqlLg.matches ? 3 : mqlSm.matches ? 2 : 1);
      update();
      mqlSm.addEventListener("change", update);
      mqlLg.addEventListener("change", update);
      return () => {
        mqlSm.removeEventListener("change", update);
        mqlLg.removeEventListener("change", update);
      };
    }, []);
    return v;
  }

  const [slide, setSlide] = useState(0);
  const visible = useVisibleCards();
  const GAP_REM = 1.5; // Tailwind gap-6
  const maxSlide = Math.max(0, MODELS.length - visible);
  // Reset slide if visible changes and current index is out of range
  useEffect(() => {
    setSlide((s) => Math.min(s, maxSlide));
  }, [maxSlide]);
  const prev = () => setSlide((s) => Math.max(0, s - 1));
  const next = () => setSlide((s) => Math.min(maxSlide, s + 1));
  // Derived layout numbers per current visible
  const stepPercent = 100 / visible; // how much to move per step in %
  const stepGapRem = GAP_REM / visible; // gap compensation per step
  const cardBasis = `calc(${stepPercent}% - ${
    (GAP_REM * (visible - 1)) / visible
  }rem)`; // width of one card

  // --- YouTube embed: lazy start when in viewport ---
  const [ytStarted, setYtStarted] = useState(false);
  const videoRef = useRef(null);
  useEffect(() => {
    const el = videoRef.current;
    if (!el || ytStarted) return;
    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting) {
          setYtStarted(true);
          obs.disconnect();
        }
      },
      { root: null, rootMargin: "0px", threshold: 0.5 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ytStarted]);
  return (
    <div className="min-h-screen text-gray-900 bg-white font-fordAntennaRegular">
      {/* HERO */}
      <section className="relative">
        {/* Aspect-ratio wrapper: mobile 768x950, desktop 1440x516 */}
        <div className="relative w-full overflow-hidden aspect-[768/950] sm:aspect-[1440/516]">
          <picture>
            <source
              srcSet="/images/roadshowev/roadshow-hero-mobile-768x950.jpg"
              media="(max-width: 640px)"
            />
            <img
              src="/images/roadshowev/roadshow-hero-desktop-1440x516.jpg"
              alt="Ford Electric Roadshow Hero"
              className="absolute inset-0 object-cover object-center w-full h-full"
              loading="eager"
              decoding="async"
              width={1440}
              height={516}
            />
          </picture>

          {/* subtle radial highlight */}
          <div
            className="absolute inset-0 pointer-events-none"
            aria-hidden="true"
            style={{
              background:
                "radial-gradient(1200px 600px at 80% -10%, rgba(0,32,91,0.15), rgba(255,255,255,0))",
            }}
          />

          {/* CTA buttons only (no text overlays) */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="absolute inset-x-0 z-20 justify-center hidden gap-3 px-4 sm:flex bottom-6 sm:bottom-8"
          >
            <a
              href="#schedule"
              className="inline-flex items-center px-5 py-3 text-lg font-semibold tracking-wide text-white transition border rounded-full border-white/40 hover:bg-white hover:text-fordBlue"
            >
              Виж графика
            </a>
            <a
              href="#models"
              className="inline-flex items-center px-5 py-3 text-lg font-semibold tracking-wide text-white transition border rounded-full border-white/40 hover:bg-white hover:text-fordBlue"
            >
              Разгледай моделите
            </a>
            <button
              type="button"
              onClick={() => {
                setPrefillCity("");
                setIsContactOpen(true);
              }}
              className="inline-flex items-center px-5 py-3 text-lg font-semibold tracking-wide text-white rounded-full"
              style={{ backgroundColor: "#00205B" /* Ford Blue */ }}
            >
              Свържи се с дилър
            </button>
          </motion.div>
        </div>
        {/* Mobile-only CTA buttons below the image */}
        <div className="px-4 mt-4 sm:hidden">
          <div className="flex flex-col gap-3">
            <a
              href="#schedule"
              className="inline-flex items-center justify-center w-full px-5 py-3 text-base font-semibold tracking-wide transition border rounded-full text-fordBlue border-fordBlue"
            >
              Виж графика
            </a>
            <a
              href="#models"
              className="inline-flex items-center justify-center w-full px-5 py-3 text-base font-semibold tracking-wide transition border rounded-full text-fordBlue border-fordBlue"
            >
              Разгледай моделите
            </a>
            <button
              type="button"
              onClick={() => {
                setPrefillCity("");
                setIsContactOpen(true);
              }}
              className="inline-flex items-center justify-center w-full px-5 py-3 text-base font-semibold tracking-wide text-white rounded-full"
              style={{ backgroundColor: "#00205B" }}
            >
              Свържи се с дилър
            </button>
          </div>
        </div>
      </section>
      <section className="px-4 py-8 mx-auto text-lg text-center bg-gray-50 text-fordBlue sm:py-12">
        <p className="max-w-3xl mx-auto">
          Тази есен ви каним на нашето специално събитие, посветено на
          електрическата мобилност, където ще се запознаете с новата генерация
          електрически автомобили на Ford.
        </p>
      </section>

      <section className="px-4 mx-auto max-w-7xl sm:py-10">
        {/* Следваща спирка */}
        {(() => {
          const sel = getNextOrCurrentStop(SCHEDULE);
          const today = startOfDayLocal(new Date());

          // Намери следващата група по най-ранна бъдеща startDate
          const nextStart = SCHEDULE.map((s) =>
            startOfDayLocal(new Date(s.startDate))
          )
            .filter((d) => d > today)
            .sort((a, b) => a - b)[0];
          const nextStops = nextStart
            ? SCHEDULE.filter(
                (s) =>
                  startOfDayLocal(new Date(s.startDate)).getTime() ===
                  nextStart.getTime()
              )
            : [];

          // Ако няма текущи и бъдещи – турът е приключил
          if (!sel && nextStops.length === 0) {
            return (
              <div className="p-6 mt-12 text-center bg-gray-100 border border-gray-200 text-fordBlue rounded-2xl">
                Тазгодишното роудшоу завърши. Очаквайте ни отново догодина!
              </div>
            );
          }

          // Ако ИМА текущи: една карта с два реда – "Днес сме в …" и отдолу "Следваща спирка …" (ако има)
          if (sel && sel.status === "now" && sel.items.length > 0) {
            const nowNames = sel.items.map((s) => s.city).join(", ");
            const startDates = sel.items.map((s) => s.startDate);
            const endDates = sel.items.map((s) => s.endDate);
            const minStart = startDates.reduce((a, b) => (a < b ? a : b));
            const maxEnd = endDates.reduce((a, b) => (a > b ? a : b));
            const nowRange = `${fmtDM(minStart)}-${fmtDM(maxEnd)}`;

            const hasNext = nextStops.length > 0;
            const nextNames = hasNext
              ? nextStops.map((s) => s.city).join(", ")
              : "";
            const nextRange = hasNext
              ? `${fmtDM(nextStops[0].startDate)}-${fmtDM(
                  nextStops[0].endDate
                )}`
              : "";

            return (
              <div className="flex flex-col items-center justify-between p-6 mt-12 text-white sm:flex-row rounded-2xl bg-gradient-to-r from-fordBlue via-fordBlue to-fordLight">
                <div className="mb-4 text-center sm:mb-0 sm:text-left">
                  <h3 className="text-lg font-semibold">
                    Днес сме в {nowNames}
                  </h3>
                  <p className="text-sm opacity-90">{nowRange}</p>
                  {hasNext && (
                    <div className="mt-3">
                      <h4 className="text-lg font-semibold">
                        Следваща спирка: {nextNames}
                      </h4>
                      <p className="text-sm opacity-90">{nextRange}</p>
                    </div>
                  )}
                </div>
                <a
                  href="#schedule"
                  className="inline-block px-4 py-2 text-sm font-semibold text-center bg-white rounded-full text-fordBlue hover:bg-gray-100"
                >
                  Към графика
                </a>
              </div>
            );
          }

          // Ако НЯМА текущи, но има бъдещи – една карта само със следващите
          if (nextStops.length > 0) {
            const nextNames = nextStops.map((s) => s.city).join(", ");
            const first = nextStops[0];
            const nextRange = `${fmtDM(first.startDate)}-${fmtDM(
              first.endDate
            )}`;
            return (
              <div className="flex flex-col items-center justify-between p-6 mt-12 text-white sm:flex-row rounded-2xl bg-gradient-to-r from-fordBlue via-fordBlue to-fordLight">
                <div className="mb-4 text-center sm:mb-0 sm:text-left">
                  <h3 className="text-lg font-semibold">
                    Следваща спирка: {nextNames}
                  </h3>
                  <p className="text-sm opacity-90">{nextRange}</p>
                </div>
                <a
                  href="#schedule"
                  className="inline-block px-4 py-2 text-sm font-semibold text-center bg-white rounded-full text-fordBlue hover:bg-gray-100"
                >
                  Към графика
                </a>
              </div>
            );
          }

          return null;
        })()}
      </section>

      {/* КРАТКО ИНТРО / ПРЕДИ КАРТАТА */}
      <section className="px-4 py-12 mx-auto max-w-7xl sm:py-16 text-fordBlue">
        {/* Заглавие + подзаглавие */}
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl font-bold sm:text-3xl">Защо да дойдеш?</h2>
          <p className="mt-2 text-lg text-gray-600">
            EV Roadshow е твоят шанс да усетиш бъдещето на Ford отблизо — тест
            драйв, експертни съвети и конкретни отговори на въпросите ти.
          </p>
        </div>

        {/* 6 ползи с иконки в плочки */}
        <div className="grid gap-6 mt-16 sm:grid-cols-3">
          <div className="p-6 text-center bg-white border border-gray-200 shadow-sm rounded-2xl">
            <h3 className="mt-4 text-xl font-semibold">Тествай модели</h3>
            <p className="mt-4 leading-tight text-gray-600">
              Усети мощността, тишината и динамиката на най-новите електрически
              Ford - преживяване, което не се забравя.
            </p>
          </div>
          <div className="p-6 text-center bg-white border border-gray-200 shadow-sm rounded-2xl">
            <h3 className="mt-4 text-xl font-semibold">
              Научи всичко за зареждането
            </h3>
            <p className="mt-4 leading-tight text-gray-600">
              Разбери как електрическите коли се справят в ежедневието – пробег,
              зареждане и разходи, с полезни съвети от нашите експерти!
            </p>
          </div>
          <div className="p-6 text-center bg-white border border-gray-200 shadow-sm rounded-2xl">
            <h3 className="mt-4 text-xl font-semibold">Специални оферти</h3>
            <p className="mt-4 leading-tight text-gray-600">
              Възползвай се от ексклузивни условия и предложения, достъпни само
              по време на събитието.
            </p>
          </div>
          <div className="p-6 text-center bg-white border border-gray-200 shadow-sm rounded-2xl">
            <h3 className="mt-4 text-xl font-semibold">Игри и награди</h3>
            <p className="mt-4 leading-tight text-gray-600">
              Забавления за всеки и шанс да спечелиш страхотни награди, защото
              преживяването трябва да е и забавно!
            </p>
          </div>
          <div className="p-6 text-center bg-white border border-gray-200 shadow-sm rounded-2xl">
            <h3 className="mt-4 text-xl font-semibold">Срещни експертите</h3>
            <p className="mt-4 leading-tight text-gray-600">
              Нашите специалисти са тук, за да отговорят на всичко, което искаш
              да знаеш за електрическата мобилност.
            </p>
          </div>
          <div className="p-6 text-center bg-gray-100 border border-gray-200 shadow-sm rounded-2xl">
            <h3 className="mt-4 text-xl font-semibold">
              Елате и усетете новата генерация автомобили на Ford – още днес!
            </h3>
          </div>
        </div>
      </section>

      <div className="mt-8" id="schedule">
        <EVRouteMap
          schedule={SCHEDULE}
          onOpenContact={(city) => {
            setPrefillCity(city || "");
            setIsContactOpen(true);
          }}
        />
      </div>

      {/* МОДЕЛИ */}
      <section
        id="models"
        className="px-4 mx-auto tracking-wide lg:block max-w-7xl sm:py-14"
      >
        {/* 3-up Slider с 4 модела */}
        <div className="relative">
          {/* Заглавие + стрелки */}
          <div className="flex items-end justify-between mb-6">
            <h2 className="text-2xl font-bold sm:text-3xl text-fordBlue">
              Модели
            </h2>
            <div className="flex items-center gap-2">
              <button
                onClick={prev}
                disabled={slide === 0}
                className="inline-flex items-center justify-center w-10 h-10 border border-gray-300 rounded-full text-fordBlue disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50"
                aria-label="Назад"
              >
                ‹
              </button>
              <button
                onClick={next}
                disabled={slide === maxSlide}
                className="inline-flex items-center justify-center w-10 h-10 border border-gray-300 rounded-full text-fordBlue disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50"
                aria-label="Напред"
              >
                ›
              </button>
            </div>
          </div>

          {/* Витрина */}
          <div className="overflow-hidden">
            <div
              className="flex gap-6 transition-transform duration-500 ease-out"
              style={{
                transform: `translateX(calc(${slide} * -${stepPercent}% - ${slide} * ${stepGapRem}rem))`,
              }}
            >
              {MODELS.map((m) => (
                <article
                  key={m.name}
                  className="shrink-0"
                  style={{ flex: `0 0 ${cardBasis}` }}
                >
                  <div className="overflow-hidden">
                    <div className="relative w-full pb-[56%]">
                      <img
                        src={m.img}
                        alt={m.name}
                        className="absolute inset-0 object-cover w-full h-full transition-transform duration-[10000ms] scale-[1.05] hover:scale-[1.1]"
                        loading="lazy"
                        decoding="async"
                      />
                      <div className="absolute inset-0 pointer-events-none" />
                    </div>
                    <div className="p-4">
                      <h3 className="text-lg font-bold text-fordBlue">
                        {m.name}
                      </h3>
                      <div className="flex flex-wrap gap-2 mt-3 text-sm">
                        <a
                          href={m.moreUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-semibold text-fordLight hover:underline"
                        >
                          Научете повече за {m.name} &rarr;
                        </a>
                        <a
                          href={m.stockUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-semibold text-fordLight hover:underline"
                        >
                          Вижте налични автомобили &rarr;
                        </a>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* Индикатори */}
          <div className="flex justify-center gap-2 mt-4">
            {Array.from({ length: maxSlide + 1 }).map((_, i) => (
              <button
                key={i}
                onClick={() => setSlide(i)}
                className={`h-2 rounded-full transition-all ${
                  slide === i ? "w-6 bg-fordLight" : "w-2 bg-gray-300"
                }`}
                aria-label={`Слайд ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-10 mx-auto tracking-wide max-w-7xl sm:py-14">
        <div className="flex items-end justify-between mb-6">
          <h2 className="text-2xl font-bold sm:text-3xl text-fordBlue">
            Предимствата на електрическите автомобили
          </h2>
        </div>
        <div className="grid gap-6 mt-16 sm:grid-cols-3">
          <div>
            <img
              src="https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_07_CX740S_Ext_Rear-3x2-1000x667-explorer-driving-rear-view.jpg"
              alt=""
              className="w-full h-auto rounded-2xl"
              loading="lazy"
              decoding="async"
            />
            <h3 className="mt-8 text-xl font-bold text-fordBlue">
              Шофиране без емисии
            </h3>
            <p className="mt-4 text-fordBlue">
              Наслади се на чисто, тихо и отговорно шофиране, което не отделя
              вредни газове в атмосферата. С електрическите автомобили на Ford
              всяко пътуване е устойчиво и безопасно за околната среда.
            </p>
          </div>
          <div>
            <img
              src="https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_08_CX740L_SPORT_SEATS-3x2-1000x667-detail-on-sport-seats.jpg"
              alt=""
              className="w-full h-auto rounded-2xl"
              loading="lazy"
              decoding="async"
            />
            <h3 className="mt-8 text-xl font-bold text-fordBlue">
              Ниски експлоатационни разходи
            </h3>
            <p className="mt-4 text-fordBlue">
              Разходите за зареждане са значително по-ниски в сравнение с
              традиционните горива. Освен това, по-малкото движещи се части
              намаляват нуждата от поддръжка, което води до по-ниски
              експлоатационни разходи.
            </p>
          </div>
          <div>
            <img
              src="https://www.fr.ford.be/content/dam/guxeu/rhd/central/brochureware/hybrid-electric-dse/column-cards/ford-hybrid_electric-eu-Column_Card_09_PUMA_CHARGING-3x2-1000x667-yellow-puma-charging.jpg"
              alt=""
              className="w-full h-auto rounded-2xl"
              loading="lazy"
              decoding="async"
            />
            <h3 className="mt-8 text-xl font-bold text-fordBlue">
              Удобство при зареждане
            </h3>
            <p className="mt-4 text-fordBlue">
              С възможности за зареждане както у дома, така и на обществени
              станции, електрическите автомобили на Ford предлагат гъвкавост и
              удобство за всекидневна употреба.
            </p>
          </div>
        </div>
      </section>
      {/* ВИДЕО */}
      <section id="video" className="px-4 mx-auto py-14 max-w-7xl">
        <div
          ref={videoRef}
          className="relative w-full overflow-hidden bg-black rounded-2xl aspect-video"
        >
          {ytStarted && (
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/PUDXet2yc10?autoplay=1&mute=1&playsinline=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=PUDXet2yc10"
              title="Ford Electric Roadshow"
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </section>
      {isContactOpen && (
        <Modal handleClose={() => setIsContactOpen(false)}>
          <div className="p-4 sm:p-6">
            <h3 className="mb-4 text-xl font-semibold text-fordBlue">
              Свържи се с дилър
            </h3>
            <ContactFormGoElectric
              defaultCity={prefillCity}
              cities={SCHEDULE.map((s) => s.city)}
              onSuccess={() => setIsContactOpen(false)}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}
